import React from 'react';
import { JourneyStrip } from './JourneyStrip';
import { CroppedImage } from './CroppedImage';
import { BRAND, MAIN_MOCKUP, REVEAL_BODY, REVEAL_EYEBROW, REVEAL_TITLE_LINE_1, REVEAL_TITLE_LINE_2, revealLines } from '../data/resinContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="reveal-title" data-id="element-303" data-mp="1pycudqw61kcn">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-304" data-mp="1b9gc710eaqyb">
        <p className="font-display text-xl font-semibold uppercase tracking-[0.08em] text-champagne-light sm:text-2xl" data-id="element-305" data-mp="1g0q09x6apm83">
          {BRAND}
        </p>
        <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-muted" data-id="element-306" data-mp="12b4ob6qwy79k">{REVEAL_EYEBROW}</p>
        <h2 id="reveal-title" className="mt-5 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] text-ivory-50 sm:text-[3.2rem]" data-id="element-307" data-mp="178wenwbwtlbn">
          {REVEAL_TITLE_LINE_1}
          <span className="block text-champagne" data-id="element-308" data-mp="xcl0f0srelek">{REVEAL_TITLE_LINE_2}</span>
        </h2>

        <div className="mt-6 border-y border-charcoal-600 py-4" data-id="element-309" data-mp="32gq098867z3w">
          <JourneyStrip data-id="element-310" data-mp="2xiep8u653ik3" />
        </div>

        <CroppedImage image={MAIN_MOCKUP} className="mx-auto mt-8 w-full max-w-md sm:max-w-lg" data-id="element-311" data-mp="2xlkficqi8qhe" />

        <ul className="mx-auto mt-8 max-w-md space-y-1" data-id="element-312" data-mp="3bh4y172bn6oa">
          {revealLines.map(line => <li key={line} className="font-display text-lg italic leading-snug text-ivory-100 sm:text-xl" data-id="element-313" data-mp="37fje51rdds4l">
              {line}
            </li>)}
        </ul>
        <p className="mx-auto mt-4 max-w-lg text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-314" data-mp="2eu9q600fglrm">{REVEAL_BODY}</p>
      </div>
    </section>;
}